<script setup lang="ts">
import { storeToRefs } from "pinia";
import { onMounted, ref, computed } from "vue";
import BannerElem from "@/components/BannerView.vue";
import LoginElem from "@/components/forms/LoginView.vue";
import CreateElem from "@/components/forms/CreateView.vue";
import ContactElem from "@/components/forms/ContactView.vue";
import MentionElem from "@/components/forms/MentionsView.vue";
import MenuElem from "@/components/MenuView.vue";
import MenuMobileElem from "@/components/MenuMobileView.vue";
import DoneView from "@/components/DoneView.vue";
import StoreMapper from "@/components/forms/StoreMapperView.vue";
import ExternalView from "@/components/ExternalLinkView.vue";

import { useOperationStore } from "@/stores/operation";
const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
interface CustomStore {
  custom_css?: string;
}

const customStore: CustomStore = operationStore?.customData ?? {};

import { elementsDirectionStore } from "@/stores/motions";
const motionsStore = elementsDirectionStore();
const { banner, blocLeft, blocRight } = storeToRefs(motionsStore);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { bannerDirection: bannerDirection, slideToReset } = motionsStore;

const path = ref<string>("register");
const pathMobile = ref<string>("login");
const reveal = ref<boolean>(false);
const status = ref<string>("wait");
const externallink = ref<string>("");
const counterHome = ref<any>(undefined);
const overquota = ref<boolean>(false);

const setPath = (newPath: string) => {
  if (newPath === "login") {
    banner.value = "right";
    setTimeout(() => {
      path.value = "register";
    }, 1000);
  } else {
    path.value = newPath;
    setTimeout(() => {
      banner.value = "left";
    }, 500);
  }
};

const setViewMobile = (newPath: string) => {
  pathMobile.value = newPath;
};

const getStatus = () => {
  if (op.value && op.value.date_debut && op.value.date_fin) {
    const dateBegin = new Date(op.value.date_debut);
    const dateOff = new Date(op.value.date_fin);
    const today = new Date();
    status.value = "open";

    if (!op.value.available) {
      status.value = "offline";
    } else if (dateOff > today && dateBegin > today) {
      status.value = "wait";
    } else if (dateOff < today) {
      status.value = "finish";
    }
  }
};

//const resetFront = () => {
//  slideToReset();
//  path.value = "register";
//};

const setExternallink = (link: string) => {
  banner.value = "left";
  externallink.value = link;
  path.value = "externallink";
  pathMobile.value = "externallink";
};

let style = ref<string>("");
onMounted(async () => {
  getStatus();
  operationStore.counterType = "HOME";
  counterHome.value = await operationStore.counterData;
  if (counterHome.value && counterHome.value.value <= 0) {
    overquota.value = true;
  }
  if (customStore?.custom_css) {
    style.value = `<style>${customStore.custom_css}</style>`;
  }
});
</script>
<template>
  <div
    v-if="operationStore.operationData && op"
    class="h-full w-full relative flex parent2 desktop:px-8"
  >
    <div class="gabarit_wrapper_mobile md:py-8">
      <div
        class="w-full h-full flex flex-col md:max-w-[90%] bg-primary-bg max-h-full m-auto overflow-auto rounded-b-[var(--border-radius-popup)]"
      >
        <div class="relative bg-red-50">
          <MenuMobileElem
            @path="setViewMobile"
            :status="status"
            :overquota="overquota"
            @externallink="setExternallink"
          />
          <BannerElem :direction="banner" />
        </div>
        <div class="!overflow-visible flex-1">
          <transition name="slide" mode="out-in">
            <LoginElem
              v-if="pathMobile == 'login'"
              key="vue1"
              @setview="setViewMobile"
              :status="status"
              :counterHome="counterHome"
            />
            <CreateElem
              key="vue2"
              v-if="pathMobile == 'register' && !overquota"
              @setview="setViewMobile"
              :status="status"
            />
            <MentionElem
              key="vue3"
              :status="status"
              @setview="setViewMobile"
              v-if="pathMobile === 'mentions'"
            />
            <ContactElem
              :op="op"
              :operationId="op?._id"
              key="vue4"
              :status="status"
              @setview="setViewMobile"
              v-if="pathMobile === 'contact'"
            />
            <StoreMapper
              key="vue5"
              :id="op?.custom?.storemapper_id"
              v-if="op?.custom?.storemapper_id && pathMobile === 'stores'"
            />
            <ExternalView
              key="vue6"
              :externallink="externallink"
              v-if="pathMobile === 'externallink'"
            />
          </transition>
        </div>
      </div>
    </div>
    <div class="gabarit_wrapper">
      <MenuElem
        @direction="bannerDirection"
        @path="setPath"
        :status="status"
        :overquota="overquota"
        @externallink="setExternallink"
      />
      <div class="gabarit">
        <div
          id="gab"
          class="desktop:absolute inset-0 w-full desktop:h-full bg-primary-bg text-primary-text"
        ></div>
        <BannerElem :direction="banner" />
        <section
          v-if="reveal"
          class="fullgab bg-primary-bg text-primary-text flex items-center text-[.95em]"
          name="full"
        >
          <DoneView />
        </section>
        <section class="gabarit-left">
          <div :class="`content slide-${blocLeft}`">
            <LoginElem
              @direction="bannerDirection"
              :status="status"
              :counterHome="counterHome"
            />
          </div>
        </section>
        <section class="gabarit-right">
          <div :class="`content slide-${blocRight}`">
            <CreateElem
              key="comp1"
              :status="status"
              @direction="bannerDirection"
              v-if="path === 'register' && !overquota"
              class="p-2"
            />
            <MentionElem
              key="comp2"
              :status="status"
              @direction="bannerDirection"
              v-if="path === 'mentions'"
              class="p-2"
            />
            <ContactElem
              :op="op"
              :operationId="op?._id"
              key="comp3"
              :status="status"
              @direction="bannerDirection"
              v-if="path === 'contact'"
              class="p-2"
            />
            <ExternalView
              key="comp4"
              :externallink="externallink"
              v-if="path === 'externallink'"
            />
          </div>
        </section>
      </div>
    </div>
    <span v-if="style" v-html="style" />
  </div>
</template>

<style lang="scss" scoped>
.slide-left {
  transform: translateX(-100%);
}

.slide-right {
  transform: translateX(100%);
}

.slide-right.slide-reset,
.slide-left.slide-reset {
  transform: translateX(0%);
}

/* Animations de transition */

.slide-leave-active,
.slide-enter-active {
  transition: 0.2s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
